<template>
    <div>
        <a-checkbox-group
            v-model="changeValue"
            :options="options"
            @change="onChange"
        />
    </div>
</template>

<script>
export default {
    name: 'SdCheckbox',
    components: {},
    props: {
        value: {
            // type: [ String, Number ],
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
    },
    computed: {
        // 是否可编辑
        isModify({ $props }){
            return Boolean($props.field.isModify);
        },
        options({ parameters }) {
            const sourceData = parameters.options || [];
            const options = [];
            sourceData.forEach(item => {
                if (item.isEnable) {
                    options.push(item);
                }
            });
            return options;
        },
        // data-entry组件参数
        parameters({ $props, $data }) {
            const parameters = $props.field.commonProperties ? JSON.parse($props.field.commonProperties).options : {};
            if (!$props.value && $data.changeValue.length === 0 && parameters.defaultValue) {
                $data.changeValue = parameters.defaultValue;
                this.$emit('update:value', $data.changeValue[$data.changeValue.length - 1]);
            }
            return parameters;
        },
    },
    data() {
        return {
            // 选中值
            changeValue: [],
        };
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                if (newVal && this.changeValue.length === 0) {
                    let changeValue = [],
                        values = newVal.split(',').map(Number);
                    values.forEach(item => {
                        changeValue.push(item);
                    });
                    this.changeValue = changeValue;
                }
                else if (!newVal && oldVal) {
                    this.changeValue = [];
                }
                this.$emit('refreshForm'); // 报考自定义关联业务
            },
            immediate: true,
        },
    },
    created() {},
    methods: {
        onChange(value){
            this.$emit('update:value', JSON.parse(JSON.stringify(value)).join(','));
        }
    },
};
</script>

<style scoped lang="less"></style>
